module.exports = __webpack_public_path__ + "img/17.157f62d0.svg";